const availableUmbroCities = [{
    id: 6,
    name: 'DKI Jakarta',
    cities: [],
    allCities: true
  },
  {
    id: 3,
    name: 'Banten',
    cities: [
      {
        id: 456,
        name: 'Tangerang (Kota)'
      },
      {
        id: 457,
        name: 'Tangerang Selatan'
      }
    ],
    allCities: false
  }, {
    id: 9,
    name: 'Jawa Barat',
    cities: [
      // {
      //   id: 23,
      //   name: 'Bandung (Kota)'
      // },
      {
        id: 54,
        name: 'Bekasi'
      },
      {
        id: 55,
        name: 'Bekasi (Kota)'
      },
      {
        id: 78,
        name: 'Bogor'
      },
      {
        id: 79,
        name: 'Bogor (Kota)'
      },
      {
        id: 115,
        name: 'Depok'
      }
    ],
    allCities: false
}]

export const validateUmbre = (provinceId, cityId) => {
  if(provinceId){
    const getProvince = availableUmbroCities.find( p => p.id === parseInt(provinceId));
    if(getProvince){
      if(getProvince.allCities) return getProvince.allCities;
      const { cities } = getProvince;
      if(cities && cityId)
        return cities.find(i => i.id === cityId ) !== undefined;
      if(provinceId && !cityId)
        return true;
    }
  }
  return false;
}